import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import Home from './views/Home';
import Location from './views/Location';
import Contact from './views/Contact';
import Team from './views/Contact/Team';
import Sponsor from './views/Sponsor';
import Education from './views/Education';
import Donate from './views/Donate';
import About from './views/About';
import VisitCongo from './views/VisitCongo';
import News from './views/News';
import Admin from './views/Admin';

function App() {
    return (
        <Router>
            <div className={"text-gray-800 "}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Location" element={<Location />} />
                    <Route path="/Contact" element={<Contact />} />
                    <Route path="/Location/Team" element={<Team />} />
                    <Route path="/Sponsor" element={<Sponsor />} />
                    <Route path="/Education" element={<Education />} />
                    <Route path="/Donate" element={<Donate />} />
                    <Route path="/About" element={<About />} />
                    <Route path="/VisitCongo" element={<VisitCongo />} />
                    <Route path="/News" element={<News />} />
                    <Route path="/News?mod" element={<News />} />
                    <Route path="/Admin" element={<Admin />} />
                </Routes>
            </div>
        </Router>
    );
}

export default App;
